export const GAP_SIZES = {
  xl: 'xl',
  l: 'l',
  m: 'm',
  s: 's'
}
